<template>
      <div class="personnel">
        <div class="mainBar">
          <div class="rightBar">
             <!-- <span>排序</span>
             <img src="../assets/img/sort.png"> -->
             <el-button @click="showAdd = true" class="add">新增</el-button>
             <!-- <el-button @click="showEdit = true" class="edit">编辑</el-button> -->
          </div>
        </div>
        <!-- 新增弹窗 -->
        <div class="dial-header" id="addPeo">
            <el-dialog title="新增人员" :visible.sync="showAdd" @close="closeDiv">
              <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="ruleForm">
                <el-form-item label="姓名:" prop="name">
                  <el-input v-model="ruleForm.name" class="name"></el-input>
                </el-form-item>
                <el-form-item label="账号:" prop="user_num">
                  <el-input v-model="ruleForm.user_num" class="user_num"></el-input>
                </el-form-item>
                <el-form-item label="手机号:" prop="phone">
                  <el-input v-model="ruleForm.phone" class="phone"></el-input>
                </el-form-item>
                <el-form-item label="直接授权权限:" prop="authorization" class="authorization">
                  <el-radio-group v-model="ruleForm.authorization">
                    <el-radio label="授权" data="1"></el-radio>
                    <el-radio label="未授权" data="0"></el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item>
                  <el-button :plain="true" type="primary" @click="showAdd = false"><div @click="saleUserPost">提交</div></el-button>
                </el-form-item>
              </el-form>
            </el-dialog>
        </div>
        <!-- 列表 -->
        <div class="main" @click="getSaleUser">
          <el-table highlight-current-row :data="saleUser.slice((
            currentPage-1)*pagesize,currentPage*pagesize)" stripe
            :header-cell-style="{'width':'15.71rem','color':'rgba(79,79,79,1)','text-align':'center','border-bottom':0}">
              <el-table-column prop="name" label="姓名" sortable>
              </el-table-column>
              <el-table-column prop="user_num" label="账号"  sortable>
              </el-table-column>
              <el-table-column prop="phone" label="手机号"  sortable>
              </el-table-column>
              <el-table-column prop="authorization" label="直接授权权限" :formatter="formatAuthorization" sortable><!-- :formatter="formatAuthorization" -->
                <template slot-scope="{row,$index}">
                  <input class="edit-cell" v-if="showEdit[$index]" v-model="row.authorization">
                  <span v-if="!showEdit[$index]">{{row.authorization}}</span>
                </template>
              
                <!-- <template slot-scope="{row,$index}">
                  <div @click="{{change($index)}}" class="authorization">
                    <el-input v-if="editable[$index]" v-model='row.authorization'>
                    </el-input>
                    <span v-else>{{row.authorization}}</span>
                  </div>
                </template> -->
              </el-table-column>

              <el-table-column prop="status" label="状态" :formatter="formatStatus" sortable>
                <template slot-scope="{row,$index}">
                  <input class="edit-cell" v-if="showEdit[$index]" v-model="row.status">
                  <span v-if="!showEdit[$index]">{{row.status}}</span>
                </template>
               <!--  <template slot-scope="{row,$index}">
                  <div @click="{{changeStatus($index)}}" class="status">
                    <el-input v-if="editable[$index]" v-model='row.status'></el-input>
                    <span v-else>{{row.status}}</span>
                  </div>
                </template> -->
              </el-table-column>
              <el-table-column prop="monthresults" label="当月业绩(元)"  sortable>
              </el-table-column>
              <el-table-column prop="allresults" label="总业绩(元)"  sortable>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="{row,$index}">
                  <el-button size="small" style="padding:0.09rem 0.15rem;" @click.native="handleEdit($index, row)">编辑</el-button>
                  <el-button size="small" style="padding:0.09rem 0.15rem;" @click.native="handleSave($index, row)">保存</el-button>
                </template>
              </el-table-column>
          </el-table>
           <!-- 分页 -->
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[5, 10, 20, 40]" 
            :page-size="pagesize"  
            layout="total, sizes, prev, pager, next, jumper"
            :total="saleUser.length">  
          </el-pagination>
        </div>
      </div>

</template>
<script>
  import axios from 'axios'
  import $ from 'jquery'
  import {delCookie,getCookie,setCookie} from '@/util/util'

  export default {
     
    data(){
      return{
        showEdit: [], //显示编辑框
        showBtn: [],
        showBtnOrdinary: true,
        editable:[],
        showAdd: false,
        saleUser:[],
        currentPage:1, //初始页
        pagesize:10, //每页的数据
        ruleForm:{
          name:'',
          user_num:'',
          phone:'',
          authorization:''
        },
        rules: {
          //新增人员判断 
          name: [
            { required: true, message: '请输入姓名', trigger: 'blur' },
            { min: 2, max: 5, message: '长度在 2 到 5 个字符', trigger: 'blur' }
          ],
          user_num: [
            { required: true, message: '请输入友友号', trigger: 'blur' },
          ],
          phone: [
            { required: true, message: '请输入手机号', trigger: 'blur' },
            { pattern: /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/, message:'请输入正确的手机号' }
          ],
          authorization: [
            { required: true, message: '请选择直接授权权限', trigger: 'change' }
          ],
        }
      }
    },
    created(){
      this.getSaleUser();
      this.saleUserPost();
    },
    methods:{
      //点击编辑
      handleEdit(index, row) {
        this.showEdit[index] = true;
        this.showBtn[index] = true;
        this.$set(this.showEdit,row,true)
        this.$set(this.showBtn,row,true)
      },
      // 保存
      handleSave(index, row) {
        this.showEdit[index] = false;
        this.showBtn[index] = false;
      },
      // 清空表单
      closeDiv(){
        this.$refs['ruleForm'].resetFields()
      },
      
      // 编辑
      // change(row){
      //   this.editable[row] = true;
      //   this.$set(this.editable,row,true)
      // },
      // // 编辑状态
      // changeStatus(row){
      //   this.editable[row] = true;
      //   this.$set(this.editable,row,true)
      // },
      // 新增销售人员
      saleUserPost:function(){
        // this.$refs[ruleForm].resetFields(); 
        var name=$('.name>.el-input__inner').val();
        var user_num=$('.user_num>.el-input__inner').val();
        var phone=$('.phone>.el-input__inner').val();
        // 判断是否授权
        var authorization=$('.is-checked').attr("data");
        const url ='/scene/saleUser';
        var params = new URLSearchParams();
        params.append('token', getCookie('session'));
        // 人员
        params.append('agent',false);
        params.append('name',name);
        params.append('userNum',user_num);
        params.append('phone',phone);
        params.append('authorization',authorization);
        this.$axios({
          method: 'post',
          url:url,
          data:params
        }).then((res)=>{
          // console.log(res.data)
          if(res.data.retCode==400){
            this.$message.error(res.data.retDesc);
          }
          if(res.data.retCode==200){
            this.$message.success(res.data.retDesc);
            // this.$refs.ruleForm.resetFields();  
          }
        });
      },
      // 初始页currentPage、初始每页数据数pagesize和数据data
      handleSizeChange: function (size) {
        this.pagesize = size;
        // console.log(this.pagesize)  //每页下拉显示数据
      },
      handleCurrentChange: function(currentPage){
        this.currentPage = currentPage;
        // console.log(this.currentPage)  //点击第几页
      },
      //状态显示转换
      formatStatus: function (row, column) {
        return row.status == 1 ? '在职' : row.status == 0 ? '离职' : '未知';
      },
      formatAuthorization: function (row, column) {
        return row.authorization == 1 ? '授权' : row.authorization == 0 ? '未授权' : '未知';
      },
      // 获取人员
      getSaleUser:function(){
        axios.get("/scene/saleUser",{
          params:{
            token:getCookie('session'),
            searchSale:true
          }
        }).then(res => {
          this.data = res.data;
          this.saleUser = res.data.data;
          // console.log(res.data.data);
          // 遍历循环授权状态
          // var listSta=[];
          // for(var i=0;i<saleUser.length;i++){
          //   var authorization=saleUser[i].authorization;
          //   listSta.push(authorization);
          // };
          // console.log(listSta)
        }).catch((err)=>{
          console.log(err);
        })
      }
    }
  }
</script>
<style scoped lang="scss">
  .edit-cell{
    width: 1rem;
    height: 0.25rem;
  }
  .mainBar{
    width:15.71rem;
    height:0.53rem;
    background:rgba(255,255,255,1); 
  }
  .rightBar{
    float: right;
  }
  .rightBar>li{
    float: left;
  }
  .main{
    width:15.71rem;
    margin-top: 0.12rem;
    background:rgba(255,255,255,1);
  }
  .rightBar>span{
    float: left;
    height:0.16rem;
    font-size:0.16rem;
    line-height: 0.53rem;
    font-family:STHeitiSC-Medium;
    font-weight:500;
    color:rgba(79,79,79,1);
  }
  .rightBar>img{
    float: left;
    width: 0.1rem;
    height: 0.16rem;
    line-height: 0.53rem;
    margin: 0.19rem 0.27rem 0 0.06rem;
  }
</style>
<style>
  .personnel .el-pagination{
    text-align: center;
  }
  .authorization>.el-input{
    width: 1rem;
  }
  .authorization>.el-input>.el-input__inner{
    text-align: center;
    height: 0.4rem;
    line-height: 0.4rem;
  }
  .status>.el-input{
    width: 1rem;
  }
  .status>.el-input>.el-input__inner{
    text-align: center;
    height: 0.4rem;
    line-height: 0.4rem;
  }
  #addPeo .el-dialog__body button{
    margin-top: 0.3rem;
    margin-left: 3.5rem;
  }
  #addPeo form .authorization>.el-form-item__label{
    width: 1.4rem;
    letter-spacing: 0;
    margin-right: 0.3rem;
  }
  #addPeo>.el-dialog__wrapper>.el-dialog{
    height: 4.5rem;
  }
  #addPeo form .el-form-item{
    margin-bottom: 0.05rem;
  }
  #addPeo form .el-form-item__label{
    width: 1.5rem;
    float: left;
    padding: 0;
    letter-spacing: 0.1rem;
  }
  #addPeo form .el-form-item__content{
    float: left;
    height: 0.4rem;
  }
  #addPeo form .el-input{
    height: 0.4rem;
  }
  #addPeo form .el-input__inner{
    height: 0.4rem;
    border-radius: 0;
    padding: 0 0.1rem;
  }
  .cell{
    text-align: center;
  }
  #addPeo .el-dialog__header{
    padding: 0.39rem 0 0.36rem 0.53rem;
  }
  #addPeo .el-dialog__title{
    height:0.26rem;
    font-size:0.26rem;
    font-family:STHeitiSC-Light;
    font-weight:300;
    color:rgba(79,79,79,1);
  }
  #addPeo .el-dialog__headerbtn{
    top: 0.05rem;
    right: 0.1rem;
  }
  #addPeo .el-dialog__body{
    padding: 0;
  }
  #addPeo .el-dialog{
    width: 4.84rem;
    height: 4rem;
    border-radius:0.12rem;
  }
  #addPeo form{
    float: left;
  }
  #addPeo form>span{
    width: 1.53rem;
    text-align: right;
    float: left;
    height:0.18rem;
    font-size:0.18rem;
    font-family:STHeitiSC-Light;
    font-weight:300;
    color:rgba(76,76,76,1);
    line-height: 0.3rem;
    margin-right: 0.06rem;
  }
  #addPeo form>i{
    float: left;
    height:0.18rem;
    font-size:0.18rem;
    font-family:STHeitiSC-Light;
    font-weight:300;
    line-height: 0.3rem;
    color:rgba(76,76,76,1);
    margin-left: 0.04rem;
  }
  #addPeo form>input[type='text']{
    float: left;
    width:2.2rem;
    height:0.3rem;
    border:0.01rem solid rgba(232,232,232,1);
    margin-bottom: 0.28rem;
  }
  #addPeo form>div{
    float: left;
  }
  #addPeo form>div>span{
    width: 1.53rem;
    text-align: right;
    float: left;
    height:0.18rem;
    font-size:0.18rem;
    font-family:STHeitiSC-Light;
    font-weight:300;
    color:rgba(76,76,76,1);
    margin-bottom: 0.35rem;
    margin-right: 0.08rem;
  }
  #addPeo form>div>input[type='radio']{
    width:0.15rem;
    height:0.15rem;
    border:1px solid rgba(170,170,170,1);
    border-radius:50%;
    float: left;
    margin-right: 0.06rem;
    margin-top: 0.08rem;
    margin-left: 0.1rem;
  }
  #addPeo form>div>i{
    float: left;
    height:0.18rem;
    font-size:0.18rem;
    font-family:STHeitiSC-Light;
    font-weight:300;
    color:rgba(76,76,76,1);
  }
  #addPeo form>div>i:nth-of-type(1){
    margin-right: 0.6rem;
  }
  #addPeo .el-dialog__body button{
    width:1rem;
    height:0.3rem;
    background:rgba(244,57,65,1);
    border-radius:0.22rem; 
    float: right;
    margin-right: 0.3rem;
    color: #fff;
  }
  .add{
    float: left;
    width:0.75rem;
    height:0.30rem;
    background:rgba(244,57,65,1);
    border-radius:0.15rem;
    border:rgba(244,57,65,1);
    color: #fff;
    letter-spacing: 0.05rem;
    margin-top: 0.12rem;
    margin-right: 0.24rem;
  }
  /*.edit{
    float: left;
    width:0.75rem;
    height:0.30rem;
    background:rgba(244,57,65,1);
    border-radius:0.15rem;
    border:rgba(244,57,65,1);
    color: #fff;
    letter-spacing: 0.05rem;
    margin-top: 0.12rem;
    margin-right: 0.14rem;
  }*/
  .el-button+.el-button {
     margin-left: 0; 
}
</style>




// WEBPACK FOOTER //
// src/views/personnel.vue